import {
  verifyProviderEmail,
  resetProviderPassword,
  createCertNumber,
  verifyCertNumber,
} from "@/api/index";

export default {
  data() {
    return {
      step: 1,
      email: "",
      maskedMobile: "",
      mobileNo: "",
      certNumber: "",
      password: "",
      passwordConfirm: "",
      error: false,
      errorMessage: "",
      loading: false,
      smsSending: false,
      smsRequested: false,
      smsVerified: false,
      phoneVerificationToken: "",
      verifying: false,
    };
  },
  methods: {
    async verifyEmail() {
      this.error = false;
      if (!this.email) {
        this.error = true;
        this.errorMessage = "이메일을 입력해주세요.";
        return;
      }
      this.loading = true;
      try {
        const res = await verifyProviderEmail({ email: this.email });
        if (res.data.status === 200) {
          this.maskedMobile = res.data.data.maskedMobile;
          this.step = 2;
        } else {
          this.error = true;
          this.errorMessage = res.data.message;
        }
      } catch (e) {
        this.error = true;
        this.errorMessage = "서버 오류가 발생했습니다.";
      }
      this.loading = false;
    },
    async requestSms() {
      this.error = false;
      if (!this.mobileNo) {
        this.error = true;
        this.errorMessage = "휴대폰번호를 입력해주세요.";
        return;
      }
      if (!/^01[016789]\d{7,8}$/.test(this.mobileNo)) {
        this.error = true;
        this.errorMessage = "휴대폰번호 형식이 올바르지 않습니다.";
        return;
      }
      this.smsSending = true;
      try {
        const res = await createCertNumber({
          mobileNo: this.mobileNo,
          flag: "findPwd",
          purpose: "providerPassword",
        });
        if (res.data.status === 200) {
          this.smsRequested = true;
          this.smsVerified = false;
          this.phoneVerificationToken = "";
          this.$alert("인증번호가 발송되었습니다.", {
            confirmButtonText: "확인",
          });
        } else {
          this.error = true;
          this.errorMessage = res.data.message;
        }
      } catch (e) {
        this.error = true;
        this.errorMessage = "인증번호 발송에 실패했습니다.";
      }
      this.smsSending = false;
    },
    async verifySms() {
      this.error = false;
      if (!this.certNumber) {
        this.error = true;
        this.errorMessage = "인증번호를 입력해주세요.";
        return;
      }
      this.verifying = true;
      try {
        const res = await verifyCertNumber({
          mobileNo: this.mobileNo,
          certNumber: this.certNumber,
          purpose: "providerPassword",
        });
        if (res.data.status === 200) {
          this.smsVerified = true;
          this.phoneVerificationToken = res.data.verificationToken || "";
        } else {
          this.error = true;
          this.phoneVerificationToken = "";
          this.errorMessage = res.data.message;
        }
      } catch (e) {
        this.error = true;
        this.errorMessage = "인증 확인에 실패했습니다.";
      }
      this.verifying = false;
    },
    goToStep3() {
      if (!this.smsVerified) return;
      this.error = false;
      this.step = 3;
    },
    async resetPassword() {
      this.error = false;
      if (!this.password) {
        this.error = true;
        this.errorMessage = "비밀번호를 입력해주세요.";
        return;
      }
      const pwRegex = /^(?=.*[a-zA-Z])(?=.*\d).{8,16}$/;
      if (!pwRegex.test(this.password)) {
        this.error = true;
        this.errorMessage = "영문, 숫자 조합 8~16자로 입력해주세요.";
        return;
      }
      if (this.password !== this.passwordConfirm) {
        this.error = true;
        this.errorMessage = "비밀번호가 일치하지 않습니다.";
        return;
      }
      this.loading = true;
      try {
        const res = await resetProviderPassword({
          email: this.email,
          mobileNo: this.mobileNo,
          password: this.password,
          phoneVerificationToken: this.phoneVerificationToken,
        });
        if (res.data.status === 200) {
          await this.$alert(
            "비밀번호가 변경되었습니다. 새 비밀번호로 로그인해주세요.",
            { confirmButtonText: "확인" }
          );
          this.$router.push("/");
        } else {
          this.error = true;
          this.errorMessage = res.data.message;
        }
      } catch (e) {
        this.error = true;
        this.errorMessage = "서버 오류가 발생했습니다.";
      }
      this.loading = false;
    },
  },
};
